import { ExternalLink, Radio } from "lucide-react";
import type { PermanentVideoChannel } from "@shared/videoChannels";
import { getVideoEmbedUrl } from "@shared/videoChannels";
import React from "react";

interface VideoPlayerProps {
  channel: PermanentVideoChannel;
  compact?: boolean;
}

export default function VideoPlayer({ channel, compact = false }: VideoPlayerProps) {
  const embedUrl = getVideoEmbedUrl(channel);
  if (!embedUrl) {
    throw new Error(`Invalid embed configuration for ${channel.slug}.`);
  }
  const Heading = compact ? "h1" : "h2";

  return (
    <section className={compact ? "video-player is-compact" : "video-player"} aria-labelledby="video-player-title">
      <div className="video-player-head">
        <div>
          <p className="home-kicker">CURRENT LIVE PLAYER</p>
          <Heading id="video-player-title" tabIndex={-1}>{channel.name}</Heading>
        </div>
        <span className="video-availability">
          <Radio size={13} aria-hidden="true" />
          Current channel player
        </span>
      </div>

      <div className="video-player-frame">
        <iframe
          key={channel.slug}
          src={embedUrl}
          title={`${channel.name} live channel`}
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>

      <div className="video-player-meta">
        <p>{channel.description} The player requests the current live stream; rendering this frame does not establish that video is playing.</p>
        <a href={channel.sourceUrl} target="_blank" rel="noreferrer">
          Official broadcaster <ExternalLink size={13} aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
